module.exports = __webpack_public_path__ + "static/4-fb0f8fe5119b9d6ef3f5550256c36458.svg";